import { DonationCampaign, DonationCampaignV1 } from '@/common/types';

export const isAcceptAfterDeadline = (
  campaign: DonationCampaign | DonationCampaignV1 | undefined,
  isV2: boolean,
) => {
  return isV2
    ? (campaign as DonationCampaign)?.campaignGoal?.acceptDonationsAfterEndDate
    : (campaign as DonationCampaignV1)?.campaignGoal
        ?.acceptDonationsAfterDeadline;
};

export const hasDeadline = (
  campaign: DonationCampaign | DonationCampaignV1 | undefined,
  isV2: boolean,
) => {
  if (isV2) {
    return (campaign as DonationCampaign)?.campaignGoal?.endDate;
  }
  return (campaign as DonationCampaignV1)?.campaignGoal?.deadline;
};

export const isAcceptAfterGoal = (
  campaign: DonationCampaign | DonationCampaignV1 | undefined,
  isV2: boolean,
) => {
  return campaign?.campaignGoal?.acceptDonationsAfterGoal;
};

export const hasCampaignGoal = (
  campaign: DonationCampaign | DonationCampaignV1 | undefined,
  isV2: boolean,
) => {
  return isV2
    ? !!(campaign as DonationCampaign)?.campaignGoal
    : !!(campaign as DonationCampaignV1)?.campaignGoalEnabled;
};
